import { defineStore } from 'pinia';
import axios from 'axios';

export const useKickoffStore = defineStore('kickoff', {
	state: () => ({
        steps: 0,
	}),
	actions: {
		
	},
	persist: true,
});
